<template>
  <div
    v-tooltip="`${$t('COMMON.NEW')} ${$t('DEALS.NOTES.CALL_NOTE')}`"
    data-cy="call-note"
    class="modal-icon"
    @click="emit('modal:show', $event, CommunicationType.call)"
  >
    <div class="relative flex h-full items-center justify-center">
      <icon-base :icon="IconTelephone" class="absolute left-[5px] top-[9px]" />
      <icon-base
        :icon="IconNotes"
        class="absolute right-[7px] top-[7px]"
        width="10"
        height="10"
        view-box="0 0 16 16"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import IconTelephone from "@/components/icons/IconTelephone.vue";
import IconNotes from "@/components/icons/IconNotes.vue";
import { CommunicationType } from "@/enums/communicationLogs";

const emit = defineEmits<{
  "modal:show": [MouseEvent, CommunicationType];
}>();
</script>
